import moment from "moment";
import React, { useEffect, useState } from "react";
import DatePicker from "react-multi-date-picker";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Select from "react-select";
import { Link, useNavigate } from "react-router-dom";
import { FetchEarnings, listing, getMembershipPurchases, getEventPurchases, getClassPurchases, getExpenseDetails, FetchArchivedReports, DeleteArchivedReport } from "./PaymentSlice";
import { saveFinanceReportToArchive } from "../../api/payment";
import { GetTeacher } from "../teacher/TeacherSlice";
import { Modal, Button } from "react-bootstrap";
import DeleteModal from "../../component/Modal/Delete";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

function FinanceManagement() {
  const dispatch = useDispatch();
  const list = useSelector((state) => state?.payment?.list);
  const archivedReports = useSelector((state) => state?.payment?.archivedReports);
  const teacherlist = useSelector((state) => state.teacher.list);
  const authCompanyId = useSelector((state) => state.auth?.company_id);
  const authUserType = useSelector((state) => state.auth?.user_type);
  const [start_date, setStart_date] = useState("");
  const [end_date, setEnd_date] = useState("");
  const [loading, setLoading] = useState(false);
  const [teacherId, setTeacherId] = useState("");
  const [view_type, setView_type] = useState("");
  const [output , setOutput] = useState(false);
  const [archiveLoading, setArchiveLoading] = useState(false);
  const [showArchivedReports, setShowArchivedReports] = useState(false);
  const [archivedReportsLoading, setArchivedReportsLoading] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteReportId, setDeleteReportId] = useState("");
  let companyOptions = [];

  // Check if user is super admin - try different possible values
  const isSuperAdmin = authUserType === 'admin' || authUserType === 'super_admin' || authUserType === 'Admin';

  // Handle delete modal
  const handleDeleteModal = () => {
    setShowDeleteModal(!showDeleteModal);
  };

  // Handle delete archived report
  const handleDeleteArchivedReport = (reportId) => {
    setDeleteReportId(reportId);
    handleDeleteModal();
  };

  // Confirm delete archived report
  const confirmDeleteArchivedReport = () => {
    if (deleteReportId) {
      dispatch(DeleteArchivedReport({ reportId: deleteReportId, companyId: selectedCompany }));
      setShowDeleteModal(false);
      setDeleteReportId("");
    }
  };
  const companiesStr = localStorage.getItem('companies');
  let defaultCompanyId = authCompanyId || null;
  
  if (companiesStr) {
    try {
      const companies = JSON.parse(companiesStr);
      if (Array.isArray(companies) && companies.length > 0) {
        companyOptions = companies.map(c => ({
          value: c.id,
          label: c.company_name
        }));
      } else {
        defaultCompanyId = authCompanyId || null;
      }
    } catch (e) {
      // If there's an error parsing companies, use the id from localStorage
      companyOptions = [];
      defaultCompanyId = authCompanyId || null;
    }
  } else {
    defaultCompanyId = authCompanyId || null;
  }
  
  const [selectedCompany, setSelectedCompany] = useState(defaultCompanyId);
  
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState({
    title: '',
    companyName: '',
    teacherName: '',
    dateRange: '',
    data: [],
    loading: false
  });

  useEffect(() => {
     dispatch(GetTeacher({ page: 1, limit: 1000000000, company_id: selectedCompany }));
  }, [dispatch, selectedCompany]);

  useEffect(() => {
    if (selectedCompany) {
      setArchivedReportsLoading(true);
      dispatch(FetchArchivedReports(selectedCompany)).finally(() => {
        setArchivedReportsLoading(false);
      });
    }
  }, [dispatch, selectedCompany]);

  useEffect(() => {
    console.log('Archived Reports State:', archivedReports);
  }, [archivedReports]);

  const handleItemClick = async (item) => {
    if (!item.ref) return;
    
    // Find the teacher's name, ensuring we compare the same data types
    // Ensure teacherlist is an array before using find
    const teacher = Array.isArray(teacherlist) 
      ? teacherlist.find(t => t && t.id && t.id.toString() === teacherId.toString())
      : null;
    
    setModalData({
      title: item.desc,
      companyName: companyOptions?.find(opt => opt.value === selectedCompany)?.label || 'All Companies',
      teacherName: !teacherId || !teacher ? 'All Teachers' : teacher.full_name,
      dateRange: `${start_date ? moment(start_date).format('MMM D, YYYY') : ''} - ${end_date ? moment(end_date).format('MMM D, YYYY') : ''}`,
      ref: item.ref,
      data: [],
      loading: true
    });
    
    
    setIsModalOpen(true);
    
    try {
      let response;
      const params = {
        company_id: selectedCompany,
        teacher_id: teacherId || undefined,
        start_date: start_date ? moment(start_date).format('YYYY-MM-DD') : undefined,
        end_date: end_date ? moment(end_date).format('YYYY-MM-DD') : undefined
      };
      
      // Call the appropriate API based on the ref
      switch(item.ref) {
        case 'total_memberships':
          response = await dispatch(getMembershipPurchases(params));
          break;
        case 'event_student':
          response = await dispatch(getEventPurchases(params));
          break;
        case 'class_student':
          response = await dispatch(getClassPurchases(params));
          break;
        case 'total_expense':
          response = await dispatch(getExpenseDetails(params));
          break;
        default:
          break;
      }
      
      setModalData(prev => ({
        ...prev,
        data: response?.payload?.data?.list || [],
        loading: false
      }));
      
    } catch (error) {
      console.error('Error fetching details:', error);
      setModalData(prev => ({
        ...prev,
        loading: false
      }));
      toast.error('Failed to load details', {  autoClose: false,  closeButton: true});
    }
  };

  const closeModal = () => {
    // Reset modal data with default structure before closing
    setModalData({
      title: '',
      companyName: '',
      teacherName: '',
      dateRange: '',
      data: [],
      loading: false,
      ref: ''
    });
    setIsModalOpen(false);
  };

  const exportToPDF = () => {
    if (!modalData.data?.length) return;

    try {
      const doc = new jsPDF();
      const title = modalData.title || 'Report';
      const dateRange = modalData.dateRange || '';
      const companyName = modalData.companyName || '';
      const teacherName = modalData.teacherName || '';
      
      // Add title
      doc.setFontSize(18);
      doc.text(title, 14, 22);
      
      // Add metadata
      doc.setFontSize(11);
      doc.setTextColor(100);
      let yPos = 30;
      
      if (companyName) {
        doc.text(`Company: ${companyName}`, 14, yPos);
        yPos += 7;
      }
      
      // if (teacherName) {
      //   doc.text(`Teacher: ${teacherName}`, 14, yPos);
      //   yPos += 7;
      // }
      
      if (dateRange) {
        doc.text(`Date Range: ${dateRange}`, 14, yPos);
        yPos += 15;
      } else {
        yPos += 8;
      }

      // Prepare table data
      let columns = [];
      let rows = [];

      if (modalData.ref === 'total_memberships') {
        columns = ['Student Name', 'Membership', 'Amount', 'Payment Date'];
        rows = modalData.data.map(item => [
          `${item?.first_name || ''} ${item?.last_name || ''}`.trim() || 'N/A',
          item.membership_name || 'N/A',
          `£${parseFloat(item?.price || 0).toFixed(2)}`,
          item.createdAt ? moment(item.createdAt).format('MMM D, YYYY') : 'N/A'
        ]);
      } else if (modalData.ref === 'event_student') {
        columns = ['Event', 'Student', 'Teacher', 'Amount', 'Date'];
        rows = modalData.data.map(item => [
          item.event_name || 'N/A',
          item.first_name + ' ' + item.last_name || 'N/A',
          item.teacher_name || 'N/A',
          `£${parseFloat(item.amount || 0).toFixed(2)}`,
          item.createdAt ? moment(item.createdAt).format('MMM D, YYYY') : 'N/A'
        ]);
      } else if (modalData.ref === 'class_student') {
        columns = ['Class', 'Student', 'Teacher', 'Amount', 'Date'];
        rows = modalData.data.map(item => [
          item.class_name || 'N/A',
          item.first_name + ' ' + item.last_name || 'N/A',
          item.teacher_name || 'N/A',
          `£${parseFloat(item.amount || 0).toFixed(2)}`,
          item.createdAt ? moment(item.createdAt).format('MMM D, YYYY') : 'N/A'
        ]);
      } else if (modalData.ref === 'total_expense') {
        columns = ['Teacher', 'Gross Income', 'Charge', 'Total Student Attended', 'Franchise Fee', 'Hall Fee', 'Net Income'];
        rows = modalData.data.map(item => [
          item.teacher_details?.full_name || 'N/A',
          `£${parseFloat(item.gross_amount || 0).toFixed(2)}`,
          `£${parseFloat(item.total_admin_commision || 0).toFixed(2)}`,
          item.total_student_attended || 'N/A',
          `£${parseFloat(item.total_franchise_fee || 0).toFixed(2)}`,
          `£${parseFloat(item.total_hall_fee || 0).toFixed(2)}`,
          `£${parseFloat(item.net_total || 0).toFixed(2)}`
        ]);
      }

      // Add table using autoTable
      autoTable(doc, {
        head: [columns],
        body: rows,
        startY: yPos,
        theme: 'grid',
        headStyles: {
          fillColor: [41, 128, 185],
          textColor: 255,
          fontStyle: 'bold'
        },
        alternateRowStyles: {
          fillColor: [245, 245, 245]
        },
        margin: { top: yPos + 10 }
      });

      // Save the PDF
      doc.save(`${title.replace(/\s+/g, '_').toLowerCase()}_${moment().format('YYYY-MM-DD')}.pdf`);
    } catch (error) {
      console.error('Error generating PDF:', error);
      toast.error('Failed to generate PDF. Please try again.', {  autoClose: false,  closeButton: true});
    }
  };

  const handleApplyFilter = () => {
    setOutput(false);
    if (!selectedCompany || selectedCompany === 0) {
      toast.error("Please select a company", {  autoClose: false,  closeButton: true});
      return;
    }
    if (!teacherId && view_type == "teacher_wise") {
      toast.error("Please select a teacher", {  autoClose: false,  closeButton: true});
      return;
    }
    if (!start_date) {
      toast.error("Please select a start date", {  autoClose: false,  closeButton: true});
      return;
    }
    if (!end_date) {
      toast.error("Please select an end date", {  autoClose: false,  closeButton: true});
      return;
    }
    if (!view_type) {
      toast.error("Please select a view type", {  autoClose: false,  closeButton: true});
      return;
    }
  
    setLoading(true);
    dispatch(
      FetchEarnings({
        company_id: selectedCompany,
        teacher_id: teacherId,
        view_type: view_type,
        ...(start_date && { start_date: moment(start_date).format("YYYY-MM-DD") }),
        ...(end_date && { end_date: moment(end_date).format("YYYY-MM-DD") })
      })
    ).then(() => {
      setLoading(false);
      setOutput(true);
    });
  };
  
  // Hide summary when filter values change
  useEffect(() => {
    setOutput(false);
    // Clear the listing when filters change
    dispatch(listing([]));
  }, [dispatch, selectedCompany, teacherId, start_date, end_date, view_type]);

  // Cleanup on component unmount
  useEffect(() => {
    return () => {
      dispatch(listing([]));
    };
  }, [dispatch]);

  const handleSaveToArchives = async () => {
    if (!list || list.length === 0) {
      toast.error("No data to archive", { autoClose: false, closeButton: true });
      return;
    }

    setArchiveLoading(true);
    
    try {
      const payload = {
        company_id: selectedCompany,
        start_date: start_date ? moment(start_date).format('YYYY-MM-DD') : '',
        end_date: end_date ? moment(end_date).format('YYYY-MM-DD') : '',
        teacher_id: (teacherId && view_type === 'teacher_wise') ? teacherId : '',
        view_type: view_type,
        summary_data: JSON.stringify(list)
      };

      const response = await saveFinanceReportToArchive(payload);
      
      if (response?.code === 1) {
        toast.success(response?.message || "Report saved to archives successfully", { autoClose: false, closeButton: true });
        dispatch(FetchArchivedReports(selectedCompany));
      } else {
        toast.error(response?.message || "Failed to save report to archives", { autoClose: false, closeButton: true });
      }
    } catch (error) {
      console.error('Error saving to archives:', error);
      toast.error("An error occurred while saving to archives", { autoClose: false, closeButton: true });
    } finally {
      setArchiveLoading(false);
    }
  };

  return (
    <article className="col-lg-9">
      {/* Details Modal */}
      <Modal show={isModalOpen} onHide={closeModal} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>{modalData.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div>
              <div><strong>Company:</strong> {modalData.companyName}</div>
              {/* <div><strong>Teacher:</strong> {modalData.teacherName}</div> */}
              <div><strong>Date Range:</strong> {modalData.dateRange}</div>
            </div>
            <Button variant="primary" onClick={exportToPDF} className="ms-3">
              <i className="bi bi-file-earmark-pdf me-1"></i> Download PDF
            </Button>
          </div>
          
          {modalData.loading ? (
            <div className="text-center py-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-2 mb-0">Loading data...</p>
            </div>
          ) : modalData.data?.length > 0 ? (
            <div className="table-responsive" style={{ maxHeight: '500px', overflow: 'auto' }}>
              <table className="table table-striped table-hover mb-0">
                <colgroup>
                  <col style={{ width: '25%' }} />
                  <col style={{ width: '30%' }} />
                  <col style={{ width: '20%' }} />
                  <col style={{ width: '25%' }} />
                </colgroup>
                <thead style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#f8f9fa' }}>
                  <tr>
                    {modalData.ref === 'total_memberships' && (
                      <>
                        <th>Sr. No</th>
                        <th>Student Name</th>
                        <th>Membership</th>
                        <th>Amount</th>
                        <th>Payment Date</th>
                      </>
                    )}
                    {modalData.ref === 'event_student' && (
                      <>
                        <th>Sr. No</th>
                        <th>Event</th>
                        <th>Student</th>
                        <th>Teacher</th>
                        <th>Amount</th>
                        <th>Payment Date</th>
                      </>
                    )}
                    {modalData.ref === 'class_student' && (
                      <>
                        <th>Sr. No</th>
                        <th>Class</th>
                        <th>Student</th>
                        <th>Teacher</th>
                        <th>Amount</th>
                        <th>Payment Date</th>
                      </>
                    )}
                    {modalData.ref === 'total_expense' && (
                      <>
                        <th>Sr. No</th>
                        <th>Teacher</th>
                        <th>Gross Income</th>
                        <th>Charge</th>
                        <th>Total Student attended</th>
                        <th>Franchise Fee</th>
                        <th>Hall Fee</th>
                        <th>Net Income</th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {modalData.data.map((item, index) => (
                    <tr key={index}>
                      {modalData.ref === 'total_memberships' && (
                        <>
                          <td>{index + 1}</td>
                          <td className="text-truncate" style={{ maxWidth: '200px' }} title={`${item?.first_name || ''} ${item?.last_name || ''}`.trim() || 'N/A'}>
                            {`${item?.first_name || ''} ${item?.last_name || ''}`.trim() || 'N/A'}
                          </td>
                          <td className="text-truncate" style={{ maxWidth: '250px' }} title={item.membership_name || 'N/A'}>
                            {item.membership_name || 'N/A'}
                          </td>
                          <td className="text-nowrap">£{parseFloat(item.price || 0).toFixed(2)}</td>
                          <td className="text-nowrap">{item.createdAt ? moment(item.createdAt).format('MMM D, YYYY') : 'N/A'}</td>
                        </>
                      )}
                      {modalData.ref === 'event_student' && (
                        <>
                          <td>{index + 1}</td>
                          <td>{item.event_name || 'N/A'}</td>
                          <td>{item.first_name +" "+item.last_name || 'N/A'}</td>
                          <td>{item.teacher_name || 'N/A'}</td>
                          <td>£{parseFloat(item.amount || 0).toFixed(2)}</td>
                          <td>{item.createdAt ? moment(item.createdAt).format('MMM D, YYYY') : 'N/A'}</td>
                        </>
                      )}
                      {modalData.ref === 'class_student' && (
                        <>
                          <td>{index + 1}</td>
                          <td>{item.class_name || 'N/A'}</td>
                          <td>{item.first_name +" "+item.last_name || 'N/A'}</td>
                          <td>{item.teacher_name || 'N/A'}</td>
                          <td>£{parseFloat(item.amount || 0).toFixed(2)}</td>
                          <td>{item.createdAt ? moment(item.createdAt).format('MMM D, YYYY') : 'N/A'}</td>
                        </>
                      )}
                      {modalData.ref === 'total_expense' && (
                        <>
                          <td>{index + 1}</td>
                          <td>{item.teacher_details?.full_name || 'N/A'}</td>
                          <td>{parseFloat(item.gross_amount || 0).toFixed(2)}</td>
                          <td>{parseFloat(item.total_admin_commision || 0).toFixed(2)}</td>
                          <td>{item.total_student_attended || 0}</td>
                          <td>{parseFloat(item.total_franchise_fee || 0).toFixed(2)}</td>
                          <td>{parseFloat(item.total_hall_fee || 0).toFixed(2)}</td>
                          <td>{parseFloat(item.net_total || 0).toFixed(2)}</td>
                        </>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="text-center py-4">
              <p className="text-muted">No data available</p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="article-body store-bd-gy">
        <div className="row">
          <div className="col-md-12">
            <h4>Finance Management</h4>
          </div>
        </div>
        {/* Company Selection - Only show if there are company options */}
        {Array.isArray(companyOptions) && companyOptions.length > 0 && (
          <>
          <div className="row mb-4">
            <div className="col-md-12">
              <label className="form-label">Select Company</label>
              <Select
                options={companyOptions}
                value={companyOptions.find(option => option.value === selectedCompany) || null}
                onChange={option => {
                  setSelectedCompany(option ? option.value : null);
                }}
                placeholder="Select Company"
                isClearable
              />
            </div>
          </div>
          {!selectedCompany && (
                <div className="col-md-12 alert alert-info mt-3">
                  Please select a company to view finance reports.
                </div>
            )}
            </>
        )}

        {/* Archived Reports Section */}
        {selectedCompany > 0 && (
          <div className="card mt-3" style={{ border: '1px solid #dee2e6', borderRadius: '8px' }}>
            <div 
              className="card-header" 
              style={{ 
                backgroundColor: '#f8f9fa', 
                cursor: 'pointer',
                padding: '15px 20px',
                borderBottom: showArchivedReports ? '1px solid #dee2e6' : 'none'
              }}
              onClick={() => setShowArchivedReports(!showArchivedReports)}
            >
              <div className="d-flex justify-content-between align-items-center">
                <h6 className="mb-0" style={{ fontWeight: '600', color: '#2c3e50' }}>
                  📁 Archived Reports
                  {archivedReports && archivedReports.length > 0 && (
                    <span className="badge bg-primary ms-2">{archivedReports.length}</span>
                  )}
                </h6>
                <span style={{ fontSize: '14px' }}>{showArchivedReports ? '▲' : '▼'}</span>
              </div>
            </div>
            
            {showArchivedReports && (
              <div className="card-body" style={{ padding: '20px' }}>
                {archivedReportsLoading ? (
                  <div className="text-center py-4">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-2 mb-0">Loading archived reports...</p>
                  </div>
                ) : archivedReports && archivedReports.length > 0 ? (
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr style={{ backgroundColor: '#f8f9fa' }}>
                          <th style={{ padding: '12px 15px', fontWeight: '600', color: '#2c3e50' }}>File Name</th>
                          <th style={{ padding: '12px 15px', fontWeight: '600', color: '#2c3e50' }}>Created Date</th>
                          <th style={{ padding: '12px 15px', fontWeight: '600', color: '#2c3e50', textAlign: 'center' }}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {archivedReports.map((report, index) => (
                          <tr key={report.id || index}>
                            <td style={{ padding: '12px 15px', verticalAlign: 'middle' }}>
                              <span style={{ color: '#dc3545', marginRight: '8px', fontSize: '16px' }}>📄</span>
                              {report.file_name}
                            </td>
                            <td style={{ padding: '12px 15px', verticalAlign: 'middle' }}>
                              {moment.utc(report.createdAt).format('MMM D, YYYY h:mm A')}
                            </td>
                            <td style={{ padding: '12px 15px', textAlign: 'center', verticalAlign: 'middle' }}>
                              <button
                                className="btn btn-sm btn-outline-primary me-2"
                                onClick={() => {
                                  window.open(`https://api.bookinclass.co.uk/uploads/reports/${report.file_name}`, '_blank');
                                }}
                                title="Download"
                              >
                               Download
                              </button>
                              {isSuperAdmin && (
                                <button
                                  className="btn btn-sm btn-outline-danger"
                                  onClick={() => handleDeleteArchivedReport(report.id)}
                                  title="Delete Report"
                                >
                                 <i className="fa fa-trash"></i> Delete
                                </button>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="text-center py-4" style={{ color: '#6c757d' }}>
                    <div style={{ fontSize: '48px', opacity: 0.3, marginBottom: '15px' }}>📂</div>
                    <p className="mb-0">No archived reports found for this company.</p>
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        <div className="row align-items-end g-2 mt-3">
          
          {/* Other Filters - Only show when company is selected */}
          {selectedCompany > 0 && (
            <>
              <div className="col-md-2">
                <select
                  className="form-control form-select"
                  value={view_type}
                  onChange={(e) => {
                    setView_type(e.target.value);
                    if (e.target.value === 'total_income') {
                      setTeacherId('');
                    }
                  }}
                >
                  <option value="">Select View Type</option>
                  <option value="total_income">Company View</option>
                  <option value="teacher_wise">Teacher View</option>
                  {/* <option value="franchise_fee">Franchise Fee</option>
                  <option value="hall_fee">Hall Fee</option>
                  <option value="commission_charges">Commission Charges</option>
                  <option value="total_students">Total Students</option>
                  <option value="memberships">Memberships</option>
                  <option value="events">Events</option>
                  <option value="class">Class</option> */}
                </select>
              </div>

              {view_type === 'teacher_wise' && (
                <div className="col-md-2">
                  <div className="d-flex align-items-center lg-justify-content-end">
                    <select
                      className="form-control form-select"
                      value={teacherId}
                      onChange={(e) => {
                        setTeacherId(e.target.value);
                      }}
                    >
                      <option value="">Select Teacher</option>
                      {teacherlist?.map((item, i) => (
                        <option value={item?.id} key={i}>
                          {item?.full_name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              )} 
              
              <div className="col-md-2">
                <DatePicker
                  value={start_date}
                  onChange={(val) => {
                    setStart_date(val.toDate());
                  }}
                  containerStyle={{width: '100%'}}
                  style={{borderRadius: '10px', border: '1px solid #ced4da', padding: '0.5rem 0.75rem', fontSize: '0.95rem', outline: 'none', boxShadow: 'none', backgroundColor: '#fff', height: '50px', width: '100%'}}
                  placeholder="Start Date"
                  className="custom-datepicker"
                />
              </div>
              <div className="col-md-2">
                <DatePicker
                  value={end_date}
                  onChange={(val) => {
                    setEnd_date(val.toDate());
                  }}
                  containerStyle={{width: '100%'}}
                  style={{borderRadius: '10px', border: '1px solid #ced4da', padding: '0.5rem 0.75rem', fontSize: '0.95rem', outline: 'none', boxShadow: 'none', backgroundColor: '#fff', height: '50px', width: '100%'}}
                  placeholder="End Date"
                  minDate={start_date || new Date()}
                  className="custom-datepicker"
                />
              </div>
            </>
          )}
          {selectedCompany > 0 && (
            <div className="col-md-2">
              <button 
                type="button" 
                className="btn btn-save p-2 fs-6 w-100"
                style={{ padding: '1rem', height: '50px', borderRadius: '8px' }}
                onClick={handleApplyFilter}
              >
                Apply Filter
              </button>
            </div>
          )}
        </div>
        {/* Summary Output Section */}
        {output && (
        <div className="row mt-4">
          <div className="col-sm-12">
            <h4 style={{ 
              color: '#2c3e50', 
              fontWeight: '600', 
              marginBottom: '20px',
              fontSize: '24px'
            }}>
              Summary Output
            </h4>
            
            <div style={{ 
              backgroundColor: '#fff', 
              borderRadius: '8px', 
              overflow: 'hidden',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}>
              <table className="table mb-0" style={{ marginBottom: 0 }}>
                <thead>
                  <tr style={{ backgroundColor: '#f8f9fa' }}>
                    <th style={{ 
                      padding: '15px 20px', 
                      fontWeight: '600',
                      color: '#2c3e50',
                      borderBottom: '2px solid #dee2e6',
                      fontSize: '14px'
                    }}>
                      Description
                    </th>
                    <th style={{ 
                      padding: '15px 20px', 
                      fontWeight: '600',
                      color: '#2c3e50',
                      borderBottom: '2px solid #dee2e6',
                      textAlign: 'center',
                      fontSize: '14px'
                    }}>
                      Count
                    </th>
                    <th style={{ 
                      padding: '15px 20px', 
                      fontWeight: '600',
                      color: '#2c3e50',
                      borderBottom: '2px solid #dee2e6',
                      textAlign: 'right',
                      fontSize: '14px'
                    }}>
                      Amount
                    </th>
                  </tr>
                </thead>
                <tbody>
                {list?.map((item, index) => (
                    <tr key={index}>
                      <td
                        style={{
                          padding: "15px 20px",
                          color: item.is_net_total ? "#2c3e50" : "#495057",
                          fontWeight: item.is_net_total ? "600" : "400",
                          borderBottom: item.is_net_total ? "none" : "1px solid #dee2e6",
                        }}
                      >
                        {item.ref ? (
                          <a 
                            href={`#${item.ref}`} 
                            style={{ 
                              textDecoration: 'none',
                              cursor: 'pointer'
                            }}
                            onClick={(e) => {
                              e.preventDefault();
                              handleItemClick(item);
                            }}
                          >
                            <div style={{ lineHeight: '1.2' }}>
                              <div>{item.desc}</div>
                              {item.note && <div style={{ fontSize: '12px', color: '#6c757d' }}>{item.note}</div>}
                            </div>
                          </a>
                        ) : (
                          <div style={{ lineHeight: '1.2' }}>
                              <div>{item.desc}</div>
                              {item.note && <div style={{ fontSize: '12px', color: '#6c757d' }}>{item.note}</div>}
                            </div>
                        )}
                      </td>
                       <td
                        style={{
                          padding: "15px 20px",
                          textAlign: "center",
                          color: item.is_net_total ? "#2c3e50" : "#495057",
                          fontWeight: item.is_net_total ? "600" : "500",
                          fontSize: item.is_net_total ? "16px" : "14px",
                          borderBottom: item.is_net_total ? "none" : "1px solid #dee2e6",
                        }}
                      >
                        {item.total_number}
                      </td>
                      <td
                        style={{
                          padding: "15px 20px",
                          textAlign: "right",
                          color: item.is_net_total ? "#2c3e50" : "#495057",
                          fontWeight: item.is_net_total ? "600" : "500",
                          fontSize: item.is_net_total ? "16px" : "14px",
                          borderBottom: item.is_net_total ? "none" : "1px solid #dee2e6",
                        }}
                      >
                        {item.amount && `£${item.amount}`}
                      </td>
                    </tr>
                  ))}

                </tbody>
              </table>
            </div>

            <div className="mt-3">
              <button 
                type="button" 
                className="btn"
                onClick={handleSaveToArchives}
                disabled={archiveLoading}
                style={{
                  backgroundColor: '#ffc107',
                  color: '#000',
                  padding: '10px 24px',
                  borderRadius: '6px',
                  fontWeight: '500',
                  border: 'none',
                  fontSize: '14px',
                  opacity: archiveLoading ? 0.6 : 1,
                  cursor: archiveLoading ? 'not-allowed' : 'pointer'
                }}
              >
                {archiveLoading ? 'Saving...' : 'Save to Archives'}
              </button>
            </div>
          </div>
        </div>
        )}

        {loading ? (
          <div style={{ textAlign: "center", padding: "40px" }}>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px" }}>
              <div className="spinner"></div>
              <p style={{ fontSize: "14px", color: "#555", margin: 0 }}>
                Please wait...Finance report are being generated.
              </p>
            </div>
          </div>
        ) : (
          <></>
        )}

      </div>

      {/* Modal for detailed view */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Details Modal"
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: '80%',
            maxWidth: '1000px',
            maxHeight: '80vh',
            overflow: 'auto',
            padding: '0',
            border: 'none',
            borderRadius: '8px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.2)'
          },
          overlay: {
            backgroundColor: 'rgba(0,0,0,0.5)'
          }
        }}
      >
        <div className="modal-header p-4" style={{ borderBottom: '1px solid #dee2e6' }}>
          <h5 className="modal-title fw-bold" style={{ fontSize: '1.5rem' }}>{modalData.title}</h5>
          <button type="button" className="btn-close" onClick={closeModal}></button>
        </div>
        <div className="modal-body p-4">
          <div className="mb-4">
            <div className="mb-2"><strong>Company:</strong> {modalData.companyName}</div>
            {/* <div className="mb-2"><strong>Teacher:</strong> {modalData.teacherName}</div> */}
            <div><strong>Date Range:</strong> {modalData.dateRange}</div>
          </div>
          
          {modalData.loading ? (
            <div className="text-center py-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <div className="mt-2">Loading details...</div>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-striped table-hover">
                <thead className="table-light">
                  <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Date</th>
                    <th>Amount</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {modalData.data.length > 0 ? (
                    modalData.data.map((item, index) => (
                      <tr key={index}>
                        <td>{item.id || index + 1}</td>
                        <td>{item.name || 'N/A'}</td>
                        <td>{item.date ? moment(item.date).format('MMM D, YYYY') : 'N/A'}</td>
                        <td>£{item.amount ? parseFloat(item.amount).toFixed(2) : '0.00'}</td>
                        <td>
                          <span className={`badge bg-${item.status === 'completed' ? 'success' : 'warning'}`}>
                            {item.status || 'pending'}
                          </span>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center py-4">No data available</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
        <div className="modal-footer p-3" style={{ borderTop: '1px solid #dee2e6' }}>
          <button 
            type="button" 
            className="btn btn-secondary" 
            onClick={closeModal}
            style={{
              padding: '8px 20px',
              borderRadius: '6px',
              fontWeight: '500',
              backgroundColor: '#6c757d',
              border: 'none'
            }}
          >
            Close
          </button>
        </div>
      </Modal>
      <DeleteModal
        page="Archived Report"
        show={showDeleteModal}
        handleShow={handleDeleteModal}
        cancel={() => {
          setShowDeleteModal(false);
          setDeleteReportId("");
        }}
        confirmDelete={confirmDeleteArchivedReport}
      />
    </article>
  );
}

export default FinanceManagement;
